import { useMutation } from '@apollo/client/react';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { REMOVE_INVITE } from './mutation';
export function useRemoveInvite() {
    const { addToast } = useToast();
    const [mutate, { loading, error }] = useMutation(REMOVE_INVITE, {
        onCompleted() {
            addToast({
                appearance: 'success',
                title: t({
                    message: 'Successfully removed invite',
                    comment: 'Success message when removing invite',
                }),
            });
        },
        onError() {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'Failed to remove invite',
                    comment: 'Message when removing invite fails',
                }),
            });
        },
        update(cache, { data }) {
            const { updateUserInvite } = data || {};
            if (updateUserInvite) {
                const { id, __typename } = updateUserInvite;
                cache.modify({
                    id: cache.identify({ id, __typename }),
                    fields(_, { DELETE }) {
                        return DELETE;
                    },
                });
            }
        },
    });
    const removeInvite = (id) => {
        mutate({ variables: { id, deletedAt: new Date().toISOString() } });
    };
    return { removeInvite, loading, error };
}
